export default "__VITE_ASSET__KwlYVv3e__"